import { dispatch } from '~/state';

const AdPlacementClient = {
  placement: {
    change: id => dispatch({ type: 'changePlacement', payload: id }),
  },
  instagramPlacement: {
    change: id => dispatch({ type: 'changeInstagramPlacement', payload: id }),
  },
};

export default AdPlacementClient;
